import { print } from "graphql";
import {
  LearningLlmStreamDocument,
  LearningLlmStreamSubscription,
  LearningLlmStreamSubscriptionVariables,
} from "@axio/graphql/generated/graphql";
import { createGraphqlSseClientV2 } from "./graphqlSseClientV2";

// V2 variant of the learning SSE client: same subscription and payload shape as
// `learningGraphqlSseClient`, but wired to the v2 base client that bypasses the
// chunk-queue pacing (v2 paces at the component layer via `useStreamBuffer`).

export type LearningLlmStreamEvent = NonNullable<LearningLlmStreamSubscription["learningLlmStream"]>;

type StreamHandlers = {
  onChunk?: (event: LearningLlmStreamEvent) => void;
  onComplete?: () => void;
  onError?: (error: Error) => void;
};

const LEARNING_LLM_STREAM_SUBSCRIPTION = print(LearningLlmStreamDocument);

const { startStream, cancelStream } = createGraphqlSseClientV2<
  LearningLlmStreamEvent,
  LearningLlmStreamSubscriptionVariables
>({
  operationName: "LearningLlmStream",
  query: LEARNING_LLM_STREAM_SUBSCRIPTION,
  getPayload: (parsed) => parsed?.data?.learningLlmStream as LearningLlmStreamEvent | undefined,
  logPrefix: "learningGraphqlSseClientV2",
});

export const cancelLearningLlmStreamV2 = () => {
  cancelStream();
};

export const startLearningLlmStreamV2 = async (
  question: string,
  controller: AbortController,
  handlers: StreamHandlers = {},
  options?: Omit<LearningLlmStreamSubscriptionVariables, "question">
) => {
  await startStream({ question, ...options }, controller, handlers);
};
